// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fi-dialogs-progress-container {
  margin-top: 30px;
}
.fi-dialogs-progress-container .fi-dialogs-progress-bar {
  height: 10px;
  margin-top: 10px;
  margin-bottom: 15px;
}
.fi-dialogs-progress-container .fi-dialogs-progress-messages {
  max-height: 160px;
  overflow-y: auto;
}
.fi-dialogs-progress-container .fi-dialogs-progress-messages .progress-message-error {
  color: var(--fi-color-red);
}`, "",{"version":3,"sources":["webpack://./Source/app/shared/fi-dialogs-generic/progress/progress.component.scss"],"names":[],"mappings":"AAAA;EACI,gBAAA;AACJ;AAAI;EACI,YAAA;EACA,gBAAA;EACA,mBAAA;AAER;AACI;EACI,iBAAA;EACA,gBAAA;AACR;AACQ;EACI,0BAAA;AACZ","sourcesContent":[".fi-dialogs-progress-container {\r\n    margin-top: 30px;\r\n    .fi-dialogs-progress-bar {\r\n        height: 10px;\r\n        margin-top: 10px;\r\n        margin-bottom: 15px;\r\n    }\r\n\r\n    .fi-dialogs-progress-messages {\r\n        max-height: 160px;\r\n        overflow-y: auto;\r\n\r\n        .progress-message-error {\r\n            color: var(--fi-color-red);\r\n        }\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
